<script>
  import AccountModal from '~/auth/AccountModal.svelte';
  import Signin from '~/auth/Signin.svelte';
  import Signup from '~/auth/Signup.svelte';
  import Verification from '~/auth/Verification.svelte';
  import FirstTimeLogin from '~/auth/PostPaymentModal.svelte';
  import ResetPassword from '~/auth/ResetPassword.svelte';
  import AuthErrorModal from '~/auth/AuthErrorModal.svelte';
  import SubscriptionLapsedModal from '~/auth/SubscriptionLapsedModal.svelte';
  import SignedOutModal from './SignedOutModal.svelte';
  import InvoiceErrorModal from './InvoiceErrorModal.svelte';
  import ChangelogModal from '~/modals/ChangelogModal.svelte';
  import MagicLink from './MagicLink.svelte';
  import PostSignupModal from '~/auth/PostSignupModal.svelte';
  import PostPaymentModal from '~/auth/PostPaymentModal.svelte';
</script>

<AccountModal />
<Signup />
<Signin />
<Verification />
<SignedOutModal />
<AuthErrorModal />
<PostSignupModal />
<PostPaymentModal />
<ResetPassword />
<MagicLink />
<FirstTimeLogin />
<SubscriptionLapsedModal />
<InvoiceErrorModal />
<ChangelogModal />
